const commonFunctions = {

  paginate: (pageObj)=>{
      if(pageObj.offset > pageObj.totalCount){
          return pageObj.offset
      }
      else{
          return pageObj.offset + pageObj.offsetIncrement;
      }
  },
  getUserID: (pageUrl)=>{
    let  url = pageUrl.split('/');
    let userId = url[url.length-1];
    return userId;
  }

}

module.exports = commonFunctions;



// WEBPACK FOOTER //
// app/commoon_functions.jsx